<template>
  <div class="enter-order-page">
    <div class="content-box">
      <div class="bg-box1"></div>
      <div class="box1" style="
          padding: 0;
          background: #fff;
          margin: 40px 10px 0;
          overflow: hidden;
          border-radius: 5px;
        ">

        <!-- 地址 -->
        <div v-if="needAddress && defaultAddress" class="user-box">
          <div class="flex-row row-between col-end">
            <div>
              <span style="font-size: 14px">收货人：</span>
              <span>{{ defaultAddress.name }}</span>
            </div>
            <div>{{ defaultAddress.mobile }}</div>
          </div>
          <div class="flex-row row-between col-center mt12">
            <div>
              <span style="font-size: 14px">收货地址：</span>
              <span v-if="defaultAddress">{{ defaultAddress.cityName }}
                {{ defaultAddress.address }}</span>
            </div>
            <van-icon class="ml8" name="arrow" style="font-size: 18px; color: #727272" @click="goAddress()" />
          </div>
        </div>

        <!-- 地址 -->
        <div v-else-if="needAddress && !defaultAddress" class="user-box">
          <div class="flex-row row-between col-end">
            <div>
              <span style="font-size: 14px"></span>
              <span></span>
            </div>
            <div></div>
          </div>
          <div class="flex-row row-between col-center mt12" @click="goAddress()">
            <div>
              <span style="font-size: 14px">还没有设置默认收货地址？<span style="color: #f00">立即设置</span></span>
            </div>
            <van-icon class="ml8" name="arrow" style="font-size: 18px; color: #727272" />
          </div>
        </div>

        <!-- 地址 -->
        <div v-else-if="needAddress" class="user-box">
          <div class="flex-row row-between col-end">
            <div>
              <span style="font-size: 14px"></span>
              <span></span>
            </div>
            <div></div>
          </div>
          <div class="flex-row row-between col-center mt12" @click="goAddress()">
            <div>
              <span style="font-size: 14px">在线发送信息，不需设置收货地址</span>
            </div>
            <van-icon class="ml8" name="arrow" style="font-size: 18px; color: #727272" />
          </div>
        </div>

        <!-- 商品列表 -->
        <div>
          <!-- 数据来自 store 和 local -->
          <div v-for="(goodsItem, index) of goodsList" :key="index">
            <div class="flex-row" style="margin-top: 27px">
              <img :src="goodsItem.goods.img" alt="" style="width: 89px; height: 89px; margin: 4px" />

              <div class="ml12" style="height: 89px">
                <div style="font-size: 15px; color: #585858; font-weight: bold">
                  {{ goodsItem.goods.name }}
                </div>
                <div class="mt4" style="font-size: 11px; color: #585858">
                  {{ Array.isArray(goodsItem.goods.spec) ? goodsItem.goods.spec.join(",") : "" }}
                </div>

                <!-- 电影信息 -->
                <div v-if="goodsDetail.cateCode && goodsDetail.cateCode.substring(0, 4) === '0002'"
                  style="font-size: 12px; color: #999">
                  {{ goodsItem.goods.cinemaname }}
                  {{ goodsItem.goods.roomname }} <br />
                  {{ goodsItem.goods.seats }} <br />
                  播放时间：{{ goodsItem.goods.playtime }}
                </div>

                <div class="flex-row row-between col-end" style="width: 240px">
                  <!-- 价格 -->
                  <div class="mt4" style="font-size: 14px; color: #ff8748">
                    <span v-if="!isPackageGoods">{{ goodsItem.goods.price | money }}</span>
                    <span class="budo-78" v-else>数量</span>
                  </div>

                  <!-- 电影 数量 -->
                  <div v-if="goodsDetail.cateCode && goodsDetail.cateCode.substring(0, 4) === '0002'"
                    style="font-size: 13px; color: #6a6a6a">
                    共 {{ goodsItem.count }} 张
                  </div>
                  <!-- 非电影 数量 -->
                  <div v-else style="font-size: 14px; color: #6a6a6a">
                    X {{ goodsItem.count }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 选数量 -->
            <div v-if="visibleBuyCountSet" class="flex-row mt22 row-between">
              <div class="budo-87">数量</div>

              <div>
                <!-- disabled or max -->
                <van-stepper v-model="goodsItem.count" min="0" :max="orderGoodsCountMax"
                  @minus="goodsCountSet(goodsItem, -1)" @plus="goodsCountSet(goodsItem, 1)" />
              </div>
            </div>
          </div>

          <div style="font-size: 15px; color: #6a6a6a">
            <div v-if="needAddress">
              <div class="flex-row mt22 row-between">
                <div>运费：</div>
                <div>{{ expressFee === 0 ? "0" : expressFee | money }}</div>
              </div>
              <div class="flex-row mt22" v-if="allowAddDesc">
                <div>备注：</div>
                <input v-model="orderDescription" class="remark-input" placeholder="订单备注 ^" type="text" />
              </div>
            </div>

            <!-- 电影需要选择身份信息 -->
            <MovieOrderForm
              v-if="(goodsDetail.cateCode && goodsDetail.cateCode.substring(0, 4) === '0002') || goodsDetail.identityAuth"
              :count="count" :identityList="identityList" />

            <!-- 电影提示信息 -->
            <MovieOrderNotice v-if="goodsDetail.cateCode && goodsDetail.cateCode.substring(0, 4) === '0002'" />

            <!-- 蜡烛和鲜花才显示 蛋糕>同城配送 或则 生活>鲜花 -->
            <CakeOrderForm v-if="isCake(goodsDetail)" ref="cake" :goodsDetail="goodsDetail" @paySetup="paySetup" />

            <!-- 蛋糕叔叔 -->
            <DgssOrderForm v-if="321 == goodsDetail.supplierId" :goodsDetail="goodsDetail" @paySetup="dgss_paySetup" />

            <!-- 海威直充 -->
            <HwRechargeForm v-if="337 == goodsDetail.supplierId" :goodsDetail="goodsDetail" ref="HwRechargeForm" />

            <!-- 健康产品 -->
            <HealthForm v-if="goodsDetail.cateCode && goodsDetail.cateCode.substring(0, 4) === '0008'" ref="healthForm"
              v-on:formCheckedEvent="healthFormCheckedHandler" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="!payEnabled">{{ errorMsg }}</div>

    <!-- 底部去支付 -->
    <div class="box4 flex-row col-center row-end">
      <div class="flex-row">
        <div v-if="!isPackageGoods" class="flex-row col-center">
          <span style="font-size: 15px">合计 : <span style="color: #ff7800; font-size: 12px"></span>
            <span style="color: #ff7800">{{ orderFee | money }}</span></span>
        </div>
        <div v-if="payEnabled" class="text-center ml8 box4-btn-1" @click="paySetup">
          支付订单
        </div>
        <div v-else class="text-center ml8 box4-btn-2">支付订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GOODS_TYPE_BOOK,
  GOODS_TYPE_GENERAL_GOODS,
  GOODS_TYPE_TICKET,
  ORDER_TYPE_HEALTH,
} from "@/api/constant";
import { api_orders_get_order_fee } from "@/api/goods-api";
import { get_default_address } from "@/api/user";
import { XIZHANG_createOrder } from "@/util/XiZhangUtil";
import request from "@/util/axios";
import { Dialog, Toast } from "vant";

import DgssOrderForm from "@/views/user-center/order-submit/components/DgssOrderForm";
import HealthForm from "@/views/user-center/order-submit/components/HealthForm";
import HwRechargeForm from "@/views/user-center/order-submit/components/HwRechargeForm";
import CakeOrderForm from "./components/CakeOrderForm";
import MovieOrderForm from "./components/MovieOrderForm";
import MovieOrderNotice from "./components/MovieOrderNotice";

export default {
  name: "index",

  components: {
    HealthForm,
    CakeOrderForm,
    MovieOrderForm,
    DgssOrderForm,
    HwRechargeForm,
    MovieOrderNotice
  },

  data() {
    return {
      defaultAddress: this.$store.getters.address,
      goodsList: this._orderInfo_().goodsList,
      cateCode: this._orderInfo_().cateCode,
      goodsTotal: this._orderInfo_().total,
      expressFee: 0,
      orderFee: 0,
      goodsCount: 0,
      visiblePaySetup: false,
      orderDescription: "",
      orderMode: 0, // 订单模式
      needAddress: true, // 是否需要设置物流地址  0=不需要，1=需要
      payEnabled: false,
      errorMsg: "",
      goodsDetail: {},
      goodsId: "",
      topicId: 0,
      count: 0,
      identityList: [],
      visibleBuyCountSet: true,
      isPackageGoods: false,
      healthFormChecked: false,
      healthFromData: {},
      hospitalOrgId: "",
      allowAddDesc: true,
      orderGoodsCountMax: 9, // 数量最大到多少

      dgssOrderExtInfo: null,

      hwRechargeExtInfo: null
    };
  },

  mounted() {
    this.load_orderGoodsCountMax();
  },

  created() {
    this.on_created();
  },

  beforeRouteEnter(to, from, next) {
    budo_log.debug("#334 from.name", from.name, to);

    let name = ["user-center-address", "user-center-info", "select-card-pay"];
    if (!name.includes(from.name)) {
      localStorage.setItem("bms.identity-list", JSON.stringify([]));
    }

    next();
  },

  methods: {
    isCake(goodsDetail) {
      return (
        goodsDetail.cateCode &&
        (goodsDetail.cateCode.substring(0, 8) === "00030115" ||
          goodsDetail.cateCode.substring(0, 8) === "00090553")
      );
    },

    load_orderGoodsCountMax() {
      var goodsList = this._orderInfo_()?.goodsList;
      if (
        !goodsList ||
        !goodsList.length ||
        goodsList.length < 1 ||
        goodsList.length > 1 ||
        goodsList[0].goods.goodsId < 1
      ) {
        budo_log.debug("#244 load_orderGoodsCountMax return", this._orderInfo_());
        return;
      }

      var formData = new FormData();
      formData.append("goodsId", goodsList[0].goods.goodsId);

      request.post("/v5/buy-quota-rule-by-goods-id", formData).then((res) => {
        budo_log.debug("#463 buy-quota-rule-by-goods-id", res);
        this.orderGoodsCountMax =
          res && res.data && res.data.orderGoodsCountMax
            ? res.data.orderGoodsCountMax
            : 9;
      });
    },

    on_created() {
      // 单品订单模式
      this.orderMode = parseInt(this.$route.query.orderMode || 0, 10);
      this.goodsType = this.$route.query.goodsType;
      this.cateId = this.$route.query.cateId;
      this.topicId = this.$route.query.topicId;

      this.needAddress = this.goodsType === GOODS_TYPE_GENERAL_GOODS || this.goodsType === GOODS_TYPE_BOOK;
      this.visibleBuyCountSet = this.goodsType === GOODS_TYPE_TICKET;

      if (this.goodsList) {
        this.$store.dispatch("actions_updateOrderInfo", {
          goodsList: this.goodsList.filter((g) => g.count > 0),
        });
        this.goodsList = this._orderInfo_().goodsList;
      }

      // 需要地址
      if (this.needAddress) {
        get_default_address().then((addr) => {
          this.defaultAddress = addr.data;

          if (addr.data) {
            this.$store.dispatch("GetDefaultAddress", addr);
            this.getOrderFee(); // 接口获取订单价格
          } else {
            this.payEnabled = false;
          }
        });
      } else {
        this.getOrderFee(); // 接口获取订单价格
      }

      budo_log.debug("#244 get_default_address this.goodsList=", this.goodsList);

      if (this.goodsList) {
        this.goodsCount = this.goodsList
          .map((g) => g.count)
          .reduce((pre, curr) => {
            return pre + curr;
          });
      }

      this.isPackageGoods = this._orderInfo_().isPackageGoods;
      this.init();
    },

    init() {
      if (this.goodsList && this.goodsList.length > 0) {
        this.cateCode = this.cateCode || this.goodsList[0].goods.cateCode;

        this.goodsDetail = {
          ...this.goodsList[0],
          ...this.goodsList[0].goods,
          cateCode: this.cateCode,
        };

        this.goodsId = this.goodsList[0].goods.goodsId;
        this.count = this.goodsList[0].count;

        sessionStorage.setItem("bms.goods-count", this.count);

        budo_log.info("#283 this.goodsDetail=", this.goodsDetail, "_orderInfo_()=", this._orderInfo_());

        if (this._orderInfo_().goodsList) {
          this._orderInfo_().goodsList.forEach((g) => {
            budo_log.debug("#358 g.goods.supplierId", g.goods.supplierId);

            if (g.goods.supplierId === 186) {
              this.allowAddDesc = false;
            }
          });
        }
      }

      this.identityList = JSON.parse(localStorage.getItem("bms.identity-list") || "[]");
    },

    goodsCountSet(goodItem, count) {
      budo_log.info("#375 goodsCountSet", goodItem, count);

      this.$nextTick(() => {
        this.orderFee = this.goodsList
          .map((item) => item.goods.price * item.count)
          .reduce((a, b) => a + b);
      });
    },

    getExtInfo(extInfo) {
      if (
        this.goodsDetail.cateCode.substring(0, 8) !== "00030115" &&
        this.goodsDetail.cateCode.substring(0, 8) !== "00090553"
      ) {
        return "";
      }

      let str = "";
      if (extInfo.time !== "") {
        str += `配送时间:${new Date().getFullYear()}-${extInfo.time.split(" ")[0]
          } ${extInfo.time.split("/")[1]},`;
      }

      if (extInfo.count !== "") {
        str += `用餐人数:${extInfo.count},`;
      }

      if (extInfo.blessing !== "") {
        str += `祝福话语:${extInfo.blessing},`;
      }

      if (
        extInfo.type !== "" &&
        this.goodsDetail.cateCode.substring(0, 8) === "00030115"
      ) {
        str += `蜡烛款式:${extInfo.type === "1" ? "彩色蜡烛" : "数字蜡烛"}`;
      }

      if (extInfo.type === "2") {
        str += `,数字蜡烛:${extInfo.candleNum}`;
      }

      return str;
    },

    handleIdentityDel(val) {
      budo_log.info("#411 handleIdentityDel", val);

      this.identityList = this.identityList.filter(
        (item) => item.cardId !== val.cardId
      );

      localStorage.setItem("bms.identity-list", JSON.stringify(this.identityList));
    },

    // 缓存一下
    _orderInfo_() {
      var cacheKey = "RC_ORDER_SUBMIT_INFO";
      var goodsType = this.$route.query.goodsType;
      var store_order = this.$store.getters.orderInfo;

      // 嘟电影 第一次
      if ("DU_MOVIE" == goodsType && store_order && store_order.tradeno) {
        budo_log.debug("#408 _orderInfo_ DU_MOVIE 1", store_order);
        localStorage.setItem(cacheKey, JSON.stringify(store_order));
        return store_order;
      }

      // 非嘟电影 第一次
      if ("DU_MOVIE" != goodsType && store_order && store_order.goodsList) {
        localStorage.setItem(cacheKey, JSON.stringify(store_order));
        return store_order;
      }

      // 刷新后
      budo_log.info("#354 _orderInfo_", store_order);
      return JSON.parse(localStorage.getItem(cacheKey));
    },

    getOrderFee() {
      var _goodsList_ = this._orderInfo_()?.goodsList || [];

      api_orders_get_order_fee({
        goodsType: this.goodsType,
        userAddressId: this.defaultAddress ? this.defaultAddress.addressId : 0,
        cityCode: this.$store.getters.city_code || "5101",
        tradeno: this._orderInfo_()?.tradeno || "",
        extInfo: JSON.stringify(this.dgssOrderExtInfo), // 蛋糕叔叔订单 根据用户选择的配送方式和 收费附件 计算费用
        goodsList: _goodsList_.map((item) => {
          return {
            goodsId: item.goods.goodsId,
            goodsCount: item.count,
            goodsSpec: item.goods.spec,
            goodsPrice: item.goods.price,
          };
        }),
      }).then((res) => {
        if (res.code === 0) {
          this.expressFee = res.data.expressFee;
          this.orderFee = res.data.orderFee;
          this.payEnabled = true;
        } else {
          this.payEnabled = false;

          Dialog.confirm({ message: res.msg || "请求失败 A, GOF" });
        }
      });
    },

    healthFormCheckedHandler(result, data) {
      this.healthFormChecked = result;
      this.healthFromData = data;
    },

    dgss_paySetup(extInfo) {
      this.dgssOrderExtInfo = extInfo;
      this.getOrderFee();
    },

    paySetup() {
      console.log("#495 paySetup, goodsDetail=", this.goodsDetail, this);

      var _this = this

      // 海威 直充
      if (this.goodsDetail.supplierId == 337) {
        var rechargeNumber = this.$refs.HwRechargeForm.getRechargeNumber()
        if (rechargeNumber) {
          Dialog.confirm({ message: "确认充值给 " + rechargeNumber }).then(() => {
            _this.hwRechargeExtInfo = {
              rechargeNumber: rechargeNumber,
              goodsSn: _this.goodsDetail.sn
            }

            budo_log.info("#518 paySetup, hwRechargeExtInfo=", _this.hwRechargeExtInfo, "goodsDetail=", _this.goodsDetail)

            this.createPayOrder()
          })
          return
        }

        Toast.fail("请填写充值账号");
        return
      }

      if (this.goodsDetail?.cateCode?.substring(0, 4) === "0008") {
        this.$refs.healthForm.checkForm();
        this.$refs.healthForm.$refs.healthFormInfo.validate().then((res) => {
          budo_log.info("#523 healthFormInfo.validate", this.healthFromData, res);
          this.createPayOrder();
        }, (error) => {
          budo_log.info("#465 paySetup error", error);

          if (error) {
            Toast.fail("请完整填写体检预约息");
          }
        });

        return
      }

      this.createPayOrder();
    },

    createPayOrder() {
      console.log("#540 createPayOrder", this);

      if (this.needAddress && !this.defaultAddress) {
        Toast.fail({ message: "请设置收货地址" });
        return;
      }

      if (
        this.goodsDetail.identityAuth === true &&
        (!this.identityList || this.identityList.length < this.count)
      ) {
        Toast.fail({ message: "请设置设置身份证信息" });
        return;
      }

      if (this.defaultAddress || !this.needAddress) {
        let updateOrderInfo = {
          expressFee: this.expressFee,
          orderFee: this.orderFee,
          userAddressId: this.defaultAddress ? this.defaultAddress.addressId : 0,
          userDescription: this.orderDescription,
          extInfo: "",
          identityList: this.identityList,
          orderType: this.get_mall_module_name(), // 这里以板块名作为订单类型 有点奇怪
        };

        if (
          this.goodsDetail.cateCode.substring(0, 8) === "00030115" ||
          this.goodsDetail.cateCode.substring(0, 8) === "00090553"
        ) {
          let extInfo = this.$refs.cake.extInfo;
          if (extInfo.time === "") {
            this.show = true;
            Toast.fail({ message: "配送时间不能为空" });
            return;
          }
          updateOrderInfo.extInfo = this.getExtInfo(extInfo);
        }

        if (this.goodsDetail?.cateCode?.substring(0, 4) === "0008") {
          const goodsParamsStr = sessionStorage.getItem("bms.goods_detail_params");
          if (goodsParamsStr) {
            const goodsParams = JSON.parse(goodsParamsStr);
            this.healthFromData.orgName = goodsParams.orgName;
            this.healthFromData.orgId = goodsParams.orgId;
          }

          this.healthFromData.packageId = sessionStorage.getItem("bms.goods_detail_sn");

          updateOrderInfo.extInfo = JSON.stringify(this.healthFromData);
          updateOrderInfo.orderType = ORDER_TYPE_HEALTH;
        }

        // 蛋糕叔叔
        if (321 == this.goodsDetail.supplierId) {
          if (!this.dgssOrderExtInfo || ("same" != this.dgssOrderExtInfo.dis_type && !this.dgssOrderExtInfo.ship_date)) {
            Toast.fail({ message: "请选择配送方式和时间" });
            return;
          }

          updateOrderInfo.extInfo = JSON.stringify(this.dgssOrderExtInfo);
        }

        if (337 == this.goodsDetail.supplierId) {
          updateOrderInfo.extInfo = JSON.stringify(this.hwRechargeExtInfo);
        }

        budo_log.info("#466 before actions_updateOrderInfo", updateOrderInfo);
        this.$store.dispatch("actions_updateOrderInfo", updateOrderInfo);

        // 如果是 APP 对接的用户 西藏 就跳转到 API PAY
        // 卡券支付 或 微信支付 或 API支付
        this.pay_by_provider_conf();
      }
    },

    pay_by_provider_conf() {
      request.post("/v5/provider-current").then((res) => {
        // 支付方式
        var payMode = res.data?.payMode;

        // 微信支付 和光同成
        if ("WX" == payMode) {
          this.pay_wx();
          return;
        }

        // 西藏 api 支付
        if ("API_xizang" == payMode) {
          this.pay_xizang();
          return;
        }

        // 默认 卡券支付
        this.pay_rc();
      });
    },

    pay_xizang() {
      XIZHANG_createOrder().then((res) => {
        budo_log.info("#531 XIZHANG_createOrder, res", res);

        if (res.code > 0) {
          Dialog.alert({ message: res.msg || "创建订单失败" });
          return;
        }

        if (res.data) {
          location.href = "/v4/api-pay?orderId=" + res.data;
        }
      });
    },

    // 老的 卡券用户 跳转到选卡支付
    pay_rc() {
      this.$router.push({
        path: "/select-card-pay",
        query: {
          orderMode: this.orderMode.toString(),
          goodsType: this.goodsType.toString(),
          cateId: this.cateId.toString(),
          topicId: this.topicId,
        },
      });
    },

    // 微信支付
    pay_wx() {
      XIZHANG_createOrder().then((res) => {
        budo_log.info("#543 XIZHANG_createOrder, res", res);

        if (res.code > 0) {
          Dialog.alert({ message: res.msg || "创建订单失败" });
          return;
        }

        if (res.data) {
          location.href = "/v4/wx-pay?orderId=" + res.data;
        }
      });
    },

    goAddress() {
      this.$router.push("/user-center-address");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";

.box4-btn-2 {
  height: 50px;
  width: 115px;
  background-color: #cccccc;
  color: white;
  line-height: 50px;
}

.box4-btn-1 {
  height: 50px;
  width: 115px;
  background-color: #fc3f3f;
  color: white;
  line-height: 50px;
}

.attribute {
  display: flex;
  margin: 20px 0;

  .title {
    width: 100px;
  }

  .van-cell {
    padding: 0;
    flex: 1;
  }
}

.card-list {
  display: flex;
  align-items: center;
  margin: 16px 10px;
  position: relative;
  font-size: 14px;
  background: #fff;
  border: 1px solid #ccc;
  padding: 5px;

  &-title {
    display: inline-block;
    width: 56px;
    margin-right: 12px;
  }
}

::v-deep {
  .van-field__control {
    border-bottom: 1px solid #ccc;
  }
}
</style>
